import { ProductTermAgreementRequest } from '../../../constants/types/product-term-type';
import instance from '../../axios/utils.ts/instance';

/**
 * 상품 약관 동의 기록 (단건)
 * @param body
 * @returns
 */
export const postProductTermAgreement = async (
  body: ProductTermAgreementRequest,
) => {
  const response = await instance.post('/v1/product/app/terms/agree', body);
  return response.data;
};

/**
 * 상품 약관 동의 기록 (여러 건)
 * @param body
 * @returns
 */
export const postProductTermAgreements = async (body: {
  agreements: ProductTermAgreementRequest[];
}) => {
  const response = await instance.post(
    '/v1/product/app/terms/agree/bulk',
    body,
  );
  return response.data;
};
